module.exports = __webpack_public_path__ + "static/img_1779-dce9e9e66d5e6eac9f2ceb0339f25d36.webp";